import { useMemo } from 'react';

import {
  useEntitySchema,
  useRouteAndQueryParams,
} from '@april9au/stack9-react';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import CountryTemplateForm from './CountryTemplateForm';
import RequirementInfo from './RequirementInfo';
import SurveyQuestionInfo from './SurveyQuestionInfo';

const S9CustomEntityFormPage = ui.S9CustomEntityFormPage.default;
const S9Tabs = ui.S9Tabs.default;

const CountryTemplateDetail = () => {
  const { schema } = useEntitySchema(entityNames.COUNTRY_TEMPLATE);

  const {
    routeParams: { id = '' },
  } = useRouteAndQueryParams();

  const items = useMemo(
    () => [
      {
        label: 'Details',
        key: 'details',
        children: <CountryTemplateForm schema={schema} />,
      },
      {
        label: 'Requirements',
        key: 'requirements',
        children: (
          <RequirementInfo
            countryTemplateId={+id}
            initialValues={{ country_template_id: +id }}
          />
        ),
      },
      {
        label: 'Survey questions',
        key: 'survey_questions',
        children: (
          <SurveyQuestionInfo
            countryTemplateId={+id}
            initialValues={{ country_template_id: +id }}
          />
        ),
      },
    ],
    [id, schema],
  );

  return (
    <S9CustomEntityFormPage
      entityKey={entityNames.COUNTRY_TEMPLATE}
      screenQueryName={EDetailsQueryNames.GetCountryTemplateDetails}
      entityId={+id}
      title={data => `Country template #${data?.id}`}
      cancelLink={AppRoutes.CountryTemplateList}
      syncFieldsOnRefetch
    >
      <S9Tabs items={items} />
    </S9CustomEntityFormPage>
  );
};
export default CountryTemplateDetail;
